import api from './api';
import { Ad, ApiResponse, PaginatedResponse } from '../types';

export const adService = {
  async getAds(campaignId: string, params?: { page?: number; limit?: number; status?: string }): Promise<PaginatedResponse<Ad>> {
    const response = await api.get(`/ads/campaign/${campaignId}`, { params });
    return response.data;
  },

  async toggleAdStatus(projectId: string, adId: string, status: 'active' | 'paused'): Promise<ApiResponse<any>> {
    const response = await api.post(`/ads/${adId}/toggle-status`, { status }, {
      headers: { 'X-Project-Id': projectId }
    });
    return response.data;
  }
};

export default adService;
